(function () {
  "use strict";

  var userScrolling = false;
  var scrollEndTimer = 0;

  window.addEventListener(
    "scroll",
    function () {
      userScrolling = true;
      window.clearTimeout(scrollEndTimer);
      scrollEndTimer = window.setTimeout(function () {
        userScrolling = false;
      }, 300);
    },
    { passive: true }
  );

  document.querySelectorAll("[data-nuvra-trending]").forEach(initTrending);

  function initTrending(root) {
    var source = root.dataset.source || (root.dataset.apiBase ? "trending" : "");
    if (source === "bestsellers") {
      initBestsellers(root);
      return;
    }

    var API_BASE = (root.dataset.apiBase || "").replace(/\/$/, "");
    var limit = Math.max(4, Number(root.dataset.limit || 8));
    var pollSeconds = Math.max(15, Number(root.dataset.pollSeconds || 25));
    var isScrollRow = root.classList.contains("nuvra-scroll-row");
    var seedScript = document.getElementById(root.dataset.seedId || "");
    var lastSignature = "";
    var soldHandles = new Set();

    if (!API_BASE) return;

    var seeds = [];
    if (seedScript) {
      try {
        seeds = JSON.parse(seedScript.textContent || "[]");
      } catch (_) {
        seeds = [];
      }
    }

    function esc(str) {
      var d = document.createElement("div");
      d.textContent = str == null ? "" : String(str);
      return d.innerHTML;
    }

    function formatMoney(cents) {
      return "$" + (Number(cents) / 100).toFixed(2);
    }

    function sellerFromTags(tags) {
      var seller = "";
      var handle = "";
      (tags || []).forEach(function (tag) {
        if (tag.indexOf("seller:") === 0) {
          handle = tag.replace("seller:", "");
          seller = handle;
        }
      });
      return { seller: seller, handle: handle };
    }

    function isHiddenProduct(product) {
      var title = (product.title || "").toLowerCase();
      var type = (product.product_type || "").toLowerCase();
      var tags = product.tags || [];
      var isSellerShop = tags.some(function (tag) {
        return String(tag).toLowerCase() === "nuvra-seller-shop";
      });
      return (
        isSellerShop ||
        title.indexOf("sticker") !== -1 ||
        type.indexOf("sticker") !== -1 ||
        title.indexOf("business card") !== -1 ||
        type.indexOf("business card") !== -1
      );
    }

    function bindCartButtons() {
      root.querySelectorAll("[data-nuvra-add]").forEach(function (btn) {
        if (btn.dataset.bound === "1") return;
        btn.dataset.bound = "1";
        btn.addEventListener("click", async function (e) {
          e.preventDefault();
          var id = this.dataset.variantId;
          if (!id) return;
          var original = this.textContent;
          this.textContent = "ADDING...";
          this.disabled = true;
          try {
            var res = await fetch((window.Shopify?.routes?.root || "/") + "cart/add.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] }),
            });
            this.textContent = res.ok ? "IN THE BAG ✓" : "OOPS";
            if (res.ok) {
              if (typeof window.nuvraNotifyCartUpdate === "function") {
                await window.nuvraNotifyCartUpdate();
              } else {
                document.dispatchEvent(
                  new CustomEvent("cart:update", {
                    bubbles: true,
                    detail: { data: { itemCount: 1, source: "nuvra-ajax-cart" } },
                  })
                );
              }
            }
          } catch {
            this.textContent = "OOPS";
          }
          var self = this;
          setTimeout(function () {
            self.textContent = original;
            self.disabled = false;
          }, 2000);
        });
      });
    }

    function buildCard(product, opts) {
      var info = sellerFromTags(product.tags);
      var seller = info.seller || product.vendor || "Nuvra Vault";
      var sellerHandle = info.handle;
      var url = "/products/" + product.handle;
      var image =
        product.featured_image ||
        (product.images && product.images[0] ? product.images[0].src : "");
      var variant = product.variants && product.variants[0];
      var price = formatMoney(variant ? variant.price : 0);
      var compare =
        variant && variant.compare_at_price > variant.price
          ? '<s class="nuvra-listing__compare">' +
            formatMoney(variant.compare_at_price) +
            "</s>"
          : "";
      var stamp = opts.justSold
        ? '<span class="nuvra-listing__stamp nuvra-listing__stamp--sold">Just Sold</span>'
        : opts.index === 0
          ? '<span class="nuvra-listing__stamp">Hot</span>'
          : "";
      var sellerLine = sellerHandle
        ? '<a href="/?view=seller-shop&handle=' +
          encodeURIComponent(sellerHandle) +
          '" class="nuvra-listing__seller-name">Designed &amp; Sold by @' +
          esc(sellerHandle) +
          "</a>"
        : '<span class="nuvra-listing__seller-name">' + esc(seller) + "</span>";
      var cartBtn =
        product.variants && product.variants.length === 1 && variant && variant.available
          ? '<button type="button" class="nuvra-listing__cart-btn" data-nuvra-add data-variant-id="' +
            variant.id +
            '">Add to cart</button>'
          : '<a href="' +
            url +
            '" class="nuvra-listing__cart-btn nuvra-listing__cart-btn--link">View listing</a>';

      return (
        '<article class="nuvra-listing nuvra-reveal is-visible' +
        (opts.justSold ? " nuvra-listing--just-sold" : "") +
        '">' +
        '<div class="nuvra-listing__media">' +
        '<a href="' +
        url +
        '" class="nuvra-listing__img-link">' +
        (image
          ? '<img src="' + esc(image) + '" alt="' + esc(product.title) + '" class="nuvra-listing__img" loading="lazy">'
          : "") +
        "</a>" +
        stamp +
        "</div>" +
        '<div class="nuvra-listing__body">' +
        '<div class="nuvra-listing__seller">' +
        '<span class="nuvra-listing__seller-avatar">' +
        esc(seller.charAt(0)) +
        "</span>" +
        sellerLine +
        '<span class="nuvra-listing__stars" aria-hidden="true">★★★★★</span>' +
        "</div>" +
        '<h3 class="nuvra-listing__title"><a href="' +
        url +
        '">' +
        esc(product.title) +
        "</a></h3>" +
        '<div class="nuvra-listing__price-row"><span class="nuvra-listing__price">' +
        price +
        "</span>" +
        compare +
        "</div>" +
        cartBtn +
        "</div></article>"
      );
    }

    async function fetchProduct(handle) {
      var res = await fetch("/products/" + encodeURIComponent(handle) + ".js", {
        cache: "no-store",
      });
      if (!res.ok) return null;
      return res.json();
    }

    async function refresh() {
      if (userScrolling) return;

      try {
        var res = await fetch(API_BASE + "/api/sales/trending?limit=" + limit, {
          cache: "no-store",
        });
        if (!res.ok) return;
        var data = await res.json();
        if (!data.trending || !data.trending.length) return;

        var signature = data.trending
          .map(function (item) {
            return item.id + ":" + item.soldAt;
          })
          .join("|");

        if (signature === lastSignature) return;
        lastSignature = signature;

        var orderedHandles = [];
        soldHandles = new Set();
        data.trending.forEach(function (item) {
          if (item.productHandle && orderedHandles.indexOf(item.productHandle) === -1) {
            orderedHandles.push(item.productHandle);
            soldHandles.add(item.productHandle);
          }
        });

        seeds.forEach(function (seed) {
          if (seed.handle && orderedHandles.indexOf(seed.handle) === -1 && orderedHandles.length < limit) {
            orderedHandles.push(seed.handle);
          }
        });

        var products = await Promise.all(
          orderedHandles.slice(0, limit * 3).map(function (handle) {
            return fetchProduct(handle);
          })
        );

        var valid = products.filter(function (product) {
          return product && !isHiddenProduct(product);
        }).slice(0, limit);
        if (!valid.length) return;

        root.innerHTML = valid
          .map(function (product, index) {
            var card = buildCard(product, {
              index: index,
              justSold: soldHandles.has(product.handle),
            });
            return isScrollRow
              ? '<div class="nuvra-scroll-item">' + card + "</div>"
              : card;
          })
          .join("");

        bindCartButtons();
        root.dispatchEvent(new CustomEvent("nuvra-trending-updated", { bubbles: true }));
      } catch (_) {
        /* keep static grid */
      }
    }

    setTimeout(refresh, 4000);
    setInterval(refresh, pollSeconds * 1000);
  }

  function initBestsellers(root) {
    var limit = Math.max(1, Number(root.dataset.limit || 20));
    var API_BASE = (root.dataset.apiBase || "").replace(/\/$/, "");
    var sectionId = root.dataset.bestsellersSection || "nuvra-bestsellers-strip";
    var isScrollRow = root.classList.contains("nuvra-scroll-row");

    function esc(str) {
      var d = document.createElement("div");
      d.textContent = str == null ? "" : String(str);
      return d.innerHTML;
    }

    function formatMoney(cents) {
      return "$" + (Number(cents) / 100).toFixed(2);
    }

    function sellerFromTags(tags) {
      var seller = "";
      var handle = "";
      (tags || []).forEach(function (tag) {
        if (tag.indexOf("seller:") === 0) {
          handle = tag.replace("seller:", "");
          seller = handle;
        }
      });
      return { seller: seller, handle: handle };
    }

    function isHiddenProduct(product) {
      var title = (product.title || "").toLowerCase();
      var type = (product.product_type || "").toLowerCase();
      var tags = product.tags || [];
      var isSellerShop = tags.some(function (tag) {
        return String(tag).toLowerCase() === "nuvra-seller-shop";
      });
      return (
        isSellerShop ||
        title.indexOf("sticker") !== -1 ||
        type.indexOf("sticker") !== -1 ||
        title.indexOf("business card") !== -1 ||
        type.indexOf("business card") !== -1
      );
    }

    function bindCartButtons(scope) {
      scope.querySelectorAll("[data-nuvra-add]").forEach(function (btn) {
        if (btn.dataset.bound === "1") return;
        btn.dataset.bound = "1";
        btn.addEventListener("click", async function (e) {
          e.preventDefault();
          var id = this.dataset.variantId;
          if (!id) return;
          var original = this.textContent;
          this.textContent = "ADDING...";
          this.disabled = true;
          try {
            var res = await fetch((window.Shopify?.routes?.root || "/") + "cart/add.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] }),
            });
            this.textContent = res.ok ? "IN THE BAG ✓" : "OOPS";
            if (res.ok) {
              if (typeof window.nuvraNotifyCartUpdate === "function") {
                await window.nuvraNotifyCartUpdate();
              } else {
                document.dispatchEvent(
                  new CustomEvent("cart:update", {
                    bubbles: true,
                    detail: { data: { itemCount: 1, source: "nuvra-ajax-cart" } },
                  })
                );
              }
            }
          } catch {
            this.textContent = "OOPS";
          }
          var self = this;
          setTimeout(function () {
            self.textContent = original;
            self.disabled = false;
          }, 2000);
        });
      });
    }

    function buildCard(product, index) {
      var info = sellerFromTags(product.tags);
      var seller = info.seller || product.vendor || "Nuvra Vault";
      var sellerHandle = info.handle;
      var url = "/products/" + product.handle;
      var image =
        product.featured_image ||
        (product.images && product.images[0] ? product.images[0].src : "");
      var variant = product.variants && product.variants[0];
      var price = formatMoney(variant ? variant.price : 0);
      var compare =
        variant && variant.compare_at_price > variant.price
          ? '<s class="nuvra-listing__compare">' +
            formatMoney(variant.compare_at_price) +
            "</s>"
          : "";
      var stamp =
        index === 0
          ? '<span class="nuvra-listing__stamp">Hot</span>'
          : index < 3
            ? '<span class="nuvra-listing__stamp">#' + (index + 1) + "</span>"
            : "";
      var sellerLine = sellerHandle
        ? '<a href="/?view=seller-shop&handle=' +
          encodeURIComponent(sellerHandle) +
          '" class="nuvra-listing__seller-name">Designed &amp; Sold by @' +
          esc(sellerHandle) +
          "</a>"
        : '<span class="nuvra-listing__seller-name">' + esc(seller) + "</span>";
      var cartBtn =
        product.variants && product.variants.length === 1 && variant && variant.available
          ? '<button type="button" class="nuvra-listing__cart-btn" data-nuvra-add data-variant-id="' +
            variant.id +
            '">Add to cart</button>'
          : '<a href="' +
            url +
            '" class="nuvra-listing__cart-btn nuvra-listing__cart-btn--link">View listing</a>';

      return (
        '<article class="nuvra-listing nuvra-reveal is-visible">' +
        '<div class="nuvra-listing__media">' +
        '<a href="' +
        url +
        '" class="nuvra-listing__img-link">' +
        (image
          ? '<img src="' + esc(image) + '" alt="' + esc(product.title) + '" class="nuvra-listing__img" loading="lazy">'
          : "") +
        "</a>" +
        stamp +
        "</div>" +
        '<div class="nuvra-listing__body">' +
        '<div class="nuvra-listing__seller">' +
        '<span class="nuvra-listing__seller-avatar">' +
        esc(seller.charAt(0)) +
        "</span>" +
        sellerLine +
        '<span class="nuvra-listing__stars" aria-hidden="true">★★★★★</span>' +
        "</div>" +
        '<h3 class="nuvra-listing__title"><a href="' +
        url +
        '">' +
        esc(product.title) +
        "</a></h3>" +
        '<div class="nuvra-listing__price-row"><span class="nuvra-listing__price">' +
        price +
        "</span>" +
        compare +
        "</div>" +
        cartBtn +
        "</div></article>"
      );
    }

    async function fetchProduct(handle) {
      var res = await fetch("/products/" + encodeURIComponent(handle) + ".js", {
        cache: "no-store",
      });
      if (!res.ok) return null;
      return res.json();
    }

    async function loadFromPopularApi() {
      if (!API_BASE) return false;
      var res = await fetch(API_BASE + "/api/products/popular?limit=" + limit, {
        cache: "no-store",
      });
      if (!res.ok) return false;
      var data = await res.json();
      var handles = (data.products || [])
        .map(function (p) {
          return p.handle;
        })
        .filter(Boolean);
      if (!handles.length) return false;

      var products = await Promise.all(handles.map(fetchProduct));
      var valid = products.filter(function (product) {
        return product && !isHiddenProduct(product);
      }).slice(0, limit);
      if (!valid.length) return false;

      root.innerHTML = valid
        .map(function (product, index) {
          var card = buildCard(product, index);
          return isScrollRow
            ? '<div class="nuvra-scroll-item">' + card + "</div>"
            : card;
        })
        .join("");

      bindCartButtons(root);
      root.dispatchEvent(new CustomEvent("nuvra-trending-updated", { bubbles: true }));
      return true;
    }

    async function loadFromShopifyBestSelling() {
      var url =
        "/collections/shop-all?sort_by=manual&sections=" +
        encodeURIComponent(sectionId);
      var res = await fetch(url, { cache: "no-store" });
      if (!res.ok) {
        url =
          "/collections/all?sort_by=best-selling&sections=" +
          encodeURIComponent(sectionId);
        res = await fetch(url, { cache: "no-store" });
      }
      if (!res.ok) return;
      var data = await res.json();
      var html = data[sectionId];
      if (!html) return;

      var doc = new DOMParser().parseFromString(html, "text/html");
      var items = doc.querySelectorAll(".nuvra-scroll-item");
      if (!items.length) return;

      root.innerHTML = Array.from(items)
        .slice(0, limit)
        .map(function (item) {
          return item.outerHTML;
        })
        .join("");

      root.querySelectorAll(".nuvra-reveal").forEach(function (el) {
        el.classList.add("is-visible");
      });

      bindCartButtons(root);
      root.dispatchEvent(new CustomEvent("nuvra-trending-updated", { bubbles: true }));
    }

    async function load() {
      try {
        var ok = await loadFromPopularApi();
        if (!ok) await loadFromShopifyBestSelling();
      } catch (_) {
        try {
          await loadFromShopifyBestSelling();
        } catch (__) {
          bindCartButtons(root);
        }
      }
    }

    load();
  }
})();
